window.$ = window.jQuery = require('jquery');
require('./lib/featherlight.min.js');
import * as cookies from "./utils/cookies.js";


export function setAlerts() {

  $(document).ready(function() {

    let closeBtn = document.getElementById("closeAlert");
    let alerts = null;
    
    if (sessionStorage.getItem("SERVICEALERT") != "1") {
      alerts = document.getElementById("alert");
    }

    if (alerts) {
      $.featherlight($(alerts), {
        variant : 'alert',
        otherClose: '#closeAlert',
        afterOpen: function(){
          this.$content.find('.C20-copy a').on('click', function(e){
            e.preventDefault();
            // cookies.setCookie("SERVICEALERT", "1", 1);
            // cookies.setSessionCookie("SERVICEALERT", "1");
            sessionStorage.setItem("SERVICEALERT", "1");
            window.location = this.href;
          });
        },
        afterClose: function(){
          // cookies.setCookie("SERVICEALERT", "1", 1);
          // cookies.setSessionCookie("SERVICEALERT", "1");
          sessionStorage.setItem("SERVICEALERT", "1");
        }
      });
    }

  });
}


// WEBPACK FOOTER //
// ./resources/js/alerts.js